<script setup lang="ts">
    import { TriangleAlertIcon } from '@lucide/vue';
    import { __ } from '@/js/stores/expressions';
    import EchoButton from '../EchoButton.vue';

    defineProps<{
        removable?: boolean;
    }>();

    defineEmits<{
        (e: 'remove'): void;
    }>();
</script>

<template>
    <div class="WidgetGraphErrorState">
        <TriangleAlertIcon class="WidgetGraphErrorState__icon size-8" aria-hidden="true" />
        <p class="WidgetGraphErrorState__title">
            {{ __('widget-invalid-filter-title') }}
        </p>
        <p class="WidgetGraphErrorState__description">
            {{ __('widget-invalid-filter-description') }}
        </p>
        <EchoButton v-if="removable" size="small" @click="$emit('remove')">
            {{ __('invalid-filters-remove') }}
        </EchoButton>
    </div>
</template>
